module.exports = __webpack_public_path__ + "media/images/default/pages/homepage/founder/1-5acb2bd84772967fe98bcc3c66d159ec.jpg";